import styled from 'styled-components';

export const Modal = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	position: fixed;
	height: 100vh;
	width: 100vw;
	top: 0;
	left: 0;
	background: rgba(175, 170, 179, 0.7);
	backdrop-filter: blur(8px);
	z-index: 90;
`;

export const ModalCard = styled.div`
	min-width: 320px;
	max-width: 90vw;
	border-radius: 10px;
	background: white;
	padding: 10px;
	max-height: 90vh;
	overflow: hidden;
	overflow-y: auto;
	box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
`;

export const Wrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	width: fit-content;
	max-width: 90vw;
	gap: 20px;
	box-sizing: border-box;
	padding: 20px 10px;
`;

export const Title = styled.h2`
	color: var(--Text-color, #29185e);
	text-align: center;
	font-family: 'Work Sans', system-ui, -apple-system, Segoe UI, Roboto,
		sans-serif;
	font-size: 22px;
	font-weight: 800;
	letter-spacing: -0.4px;
	margin: 0;
`;

export const SubTitle = styled.p`
	color: var(--Text-color, #29185e);
	text-align: center;
	font-family: 'Work Sans', system-ui, -apple-system, Segoe UI, Roboto,
		sans-serif;
	font-size: 13px;
	font-weight: 500;
	line-height: 1.5;
	margin: 0px;
`;

export const SectionLabel = styled.p`
	color: var(--Text-color, #29185e);
	text-align: center;
	font-family: 'Work Sans', system-ui, -apple-system, Segoe UI, Roboto,
		sans-serif;
	font-size: 14px;
	font-weight: 700;
	line-height: 1.4;
	margin: 0;
`;

export const Info = styled.p`
	color: var(--Text-color, #29185e);
	text-align: center;
	font-family: 'Work Sans', system-ui, -apple-system, Segoe UI, Roboto,
		sans-serif;
	font-size: 12px;
	font-weight: 500;
	line-height: 1.4;
	margin: 0;
`;

export const FlexColumn = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const ActionsRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	margin: 0;
	flex-wrap: wrap;
`;

export const LinkButton = styled.a`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	text-decoration: none;
	border: 1px solid rgba(41, 24, 94, 0.2);
	border-radius: 12px;
	padding: 10px 14px;
	font-family: 'Work Sans', system-ui, -apple-system, Segoe UI, Roboto,
		sans-serif;
	font-size: 13px;
	font-weight: 600;
	color: var(--Text-color, #29185e);
	background: #fff;
	transition: transform 0.08s ease, box-shadow 0.2s ease, background 0.2s ease;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
	width: 100%;

	&:hover {
		transform: translateY(-1px);
		box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
		background: rgba(41, 24, 94, 0.03);
	}

	&:active {
		transform: translateY(0);
	}
`;

export const PrimaryButton = styled.button`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	border: none;
	border-radius: 12px;
	padding: 12px 16px;
	font-family: 'Work Sans', system-ui, -apple-system, Segoe UI, Roboto,
		sans-serif;
	font-size: 14px;
	font-weight: 700;
	color: white;
	background: linear-gradient(135deg, #5a3df5 0%, #29185e 100%);
	box-shadow: 0 6px 14px rgba(90, 61, 245, 0.25);
	cursor: pointer;
	transition: transform 0.08s ease, box-shadow 0.2s ease, opacity 0.2s ease;

	&:hover {
		box-shadow: 0 10px 20px rgba(90, 61, 245, 0.35);
	}
	&:active {
		transform: translateY(1px);
	}
`;

export const Divider = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	color: #8b85a6;
	font-size: 11px;
`;

export const List = styled.ul`
	list-style: none;
	padding: 0;
	margin: 0;
	display: grid;
	grid-template-columns: 1fr;
	gap: 8px;

	@media (min-width: 560px) {
		grid-template-columns: 1fr 1fr;
	}
`;

export const ListItem = styled.li`
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 8px;
	border-radius: 10px;
	background: rgba(41, 24, 94, 0.04);
	border: 1px dashed rgba(41, 24, 94, 0.15);
`;
